<template>
  <DefaultLayout v-if="collection">
    <div class="d-lg-none d-xl-none mt-n6"></div><div v-if="newFile" class="d-none d-md-none d-lg-block mt-n3"></div>
    <header class="py-4 bg-gradient-info">
      <div v-if="collection && managedNetworks" class="container">
        <div v-if="newFile" class="row">
          <div class="alert alert-success mt-0 mb-n2">{{ $t('upload-complete-please-add-more-information-to-this-collection') }}</div>
        </div>
        <div v-else class="row">
          <!-- Breadcrumbs -->
          <nav aria-label="breadcrumb" style="padding-left: 0 !important;">
            <ol class=" mt-2 breadcrumb align-middle">
              <li class="breadcrumb-item">
                <a :href="network ? '/networks/' + network.slug + '/collections/' + collection.slug : '/networks/collections/' + collection.slug" class="text-primary fw-bold">
                  {{ collection.title.slice(0, 15) }}<span v-if="collection.title.length > 15" class="ms-0">...</span>
                </a>
              </li>
              <li class="breadcrumb-item">
                <a class="text-secondary fw-bold">
                  {{ $t('edit-collection') }}
                </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </header>
    <div class="container">
      <NetworkMediaCollectionForm :form="collectionForm" :managedNetworks="managedNetworks" :brandNewCollection="newFile" :busy="busy" @collection-form-updated="collectionFormUpdated" />
      <a v-if="newFile" :href="'/networks/' + network.slug + '/collections/' + collection.slug" class="btn bg-primary text-white mt-2">
        {{ $t('save-and-go-to-collection') }}
      </a>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/views/layouts/default/';
import NetworkMediaCollectionForm from '@/components/forms/collection/Form.vue';
import moment from 'moment';

export default {
  components: {
    DefaultLayout,
    NetworkMediaCollectionForm,
  },
  props: {
    collection_slug: {
      type: String,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
    newFile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busy: true,
      collection: null,
      collectionForm: {},
      managedNetworks: null,
      formLeaveWithoutSave : false,
    };
  },
  watch: {
    collection_slug(newV) {
      if (newV != this.collection.slug) this.refresh();
    },
  },
  mounted() {
    this.refresh();
    this.$bus.on('network-media-collection-form-submit', (form, shouldRedirect) => {
      this.onSubmitEvent(form, shouldRedirect);
    });
    this.$bus.on('collection-reload-event', () => this.refresh(true));
    this.$store.dispatch('loadManagedNetworks').then(networks => {
      this.managedNetworks = networks;
    });
  },
  beforeDestroy() {
    this.$bus.off('network-media-collection-form-submit');
    this.$bus.off('collection-reload-event');
  },
  beforeRouteLeave (to) {
    if(this.formLeaveWithoutSave && !this.newFile) {
      const answer = window.confirm('Do you really want to leave? You have unsaved changes!')
      if (answer) {
        window.location.href = to.path;
      } else {
        return false;
      }
    } else {
      window.location.href = to.path;
    }
  },
  methods: {
    collectionFormUpdated(value){
      this.formLeaveWithoutSave = value;
    },
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY hh:mma');
    },
    // check the route parameter and the store, and refresh it if needed
    refresh(forceRefresh = false) {
      if (this.collection == null || this.collection.slug != this.collection_slug || forceRefresh) {
        // refresh it!
        this.busy = true;
        this.$http.get('networks/collections/' + this.collection_slug + '?load_media_relations').then(resp => {
          this.collection = resp.data;
          this.collectionForm = Object.assign({}, this.collectionForm, {
            id: this.collection.id,
            slug: this.collection.slug,
            name: this.collection.title,
            permission: this.collection.permission,
            description: this.collection.description,
            tags: this.collection.tags,
            publish_date: new Date(this.collection.publish_date + ' UTC'),
            networks: this.collection.networks,
            collection: this.collection.media,
            is_organized: this.collection.is_organized,
            organized_data: this.collection.organized_data,
            can_download: this.collection.can_download,
          });
          this.busy = false;
        });
      }
    },
    onSubmitEvent(form, shouldRedirect = true) {
      this.busy = true;
      this.$http
        .put('networks/collections/' + this.collection_slug, form)
        .then(resp => {
          this.collection_slug = resp.data.slug;
          this.busy = false;
          if (!shouldRedirect) return;
        })
        .catch(() => {
          this.busy = false;
        });
    },
  },
};
</script>